import React from 'react';
import { StyledPolicyHeading, StyledPolicyIcon } from './styledPolicyHeading';

interface IPolicyHeadingProps {
  policyType: string;
  policyTitle: string;
  as?: ((...args: any[]) => any) | string;
  tag?: ((...args: any[]) => any) | string;
  className?: string;
}

const PolicyHeading = ({ policyType, policyTitle, as, tag, className }: IPolicyHeadingProps): JSX.Element => (
  <StyledPolicyHeading as={as} tag={tag} className={className} data-test-id="PolicyHeading">
    <StyledPolicyIcon type={policyType} data-test-id="PolicyHeading-icon" />
    {policyTitle}
  </StyledPolicyHeading>
);

export default PolicyHeading;
